export default __webpack_public_path__ + "static/media/nifco_logo.bca1f479.png";